import { oneColor, twoColor, fullColor, transferPrints } from "../../images";
let screenPrintingList = [
  {
    img: oneColor,
    title: "1 COLOR",
  },
  {
    img: twoColor,
    title: "2 COLOR",
  },
  {
    img: fullColor,
    title: "FULL-COLOR HYBRID PRINTING",
  },
  {
    img: transferPrints,
    title: "TRANSFER PRINTS",
  },
];
export default screenPrintingList;
